import React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import useStyles from './styles';
import dataStorage from 'dataStorage';
import MailIcon from '@mui/icons-material/Mail'

export default function Footer() {
    const classes = useStyles();

    return (
        <div className={classes.appFooter} align="center">
            <Typography
                variant="body2"
                align="center"
                component='span'
            >
                Customer support:&nbsp;&nbsp;&nbsp;
                {<MailIcon style={{ marginBottom: -2, fontSize: 16 }} />}&nbsp;
                <Link className='emailLink' target="_blank" href={`mailto:${dataStorage.config?.supportEmail}`}>
                    {dataStorage.config?.supportEmail}
                </Link>
            </Typography>
            <div style={{ height: 8 }} />
            <Typography
                variant="body2"
                align="center"
            >
                {dataStorage.config?.footer}
            </Typography>
            <Typography
                variant="body2"
                align="center"
            >
                {dataStorage.config?.footerAddition}
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 5, cursor: 'pinter' }} onClick={() => {
                window.open('https://www.novus-fintech.com/', '_blank')
            }}>
                <Typography component='span'>Powered by</Typography>
                <img className='darkResource' style={{ height: 20, marginLeft: 8 }} src='/images/logos/NovusFintechDark.svg' alt='footer_logo' />
                <img className='lightResource' style={{ height: 20, marginLeft: 8 }} src='/images/logos/NovusFintechLight.svg' alt='footer_logo' />
            </div>
        </div>
    );
}
